import { render, staticRenderFns } from "./stayCourse.vue?vue&type=template&id=8871141a&scoped=true&"
import script from "./stayCourse.vue?vue&type=script&lang=js&"
export * from "./stayCourse.vue?vue&type=script&lang=js&"
import style0 from "./stayCourse.vue?vue&type=style&index=0&id=8871141a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8871141a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8871141a')) {
      api.createRecord('8871141a', component.options)
    } else {
      api.reload('8871141a', component.options)
    }
    module.hot.accept("./stayCourse.vue?vue&type=template&id=8871141a&scoped=true&", function () {
      api.rerender('8871141a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lesson/component/stayCourse.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/lesson/component/stayCourse.vue
// module id = vjDm
// module chunks = 0